import React, { useState, useEffect } from 'react';

import './UploadAvatar.css'; // Your custom styles

import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';
import 'bootstrap/dist/css/bootstrap.min.css';


function ContactUs() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            

            <NRDRUHSHeader />

            {/* ISSN Content */}
            <div className="container" style={{ paddingTop: 60 }}>
                <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>CONTACT US</h2>
            </div>

            <div className="container">
                <div className="row" style={{ marginBottom: 120 }}>
                    <div className="col-md-2" style={{ padding: 30 }}></div>

                    <div className="col-md-8" style={{ padding: 15, textAlign: 'center' }}>
                        <p style={{ textAlign: 'center', lineHeight: 1.5 }}>
                            <br />
                            <strong>National Research Denticon</strong>   <br />
                            An Official Publication of Rajasthan University of Health Sciences, Jaipur


                            <br />

                            Subhash Nagar, Jhotwara Road, Jaipur – 302 016
                            <br /> <br />
                            <strong>Call Us:</strong>

                            <br />
                            +91-9460654279
                            <br />
                            <br />
                            <strong>For Technical Queries:</strong>
                            <br />
                            Pradeep Khemnani on +91-9772744738
                            <br />
                            <br />
                            <strong>Email:</strong><br />
                            nrdjournal@rhusraj.org
                        </p>

                    </div>

                    <div className="col-md-2" style={{ padding: 15 }}></div>
                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default ContactUs;
